// const IP = "http://localhost";
// const PORT = "28888";
// const HOST = IP + ":" + PORT;
const HOST = "https://tritonplanpro.herokuapp.com";

const LOGIN = function() {
    return HOST + "/login";
};
const REGISTER = function() {
    return HOST + "/register";
};
const LOGOUT = function() {
    return HOST + "/logout";
};

const GET_PLANS = function() {
    return HOST + "/plan/get";
};

const GET_COURSES_LIST = function(planId) {
    return `${HOST}/plan/${planId}/coursesLists`;
};

const ADD_PLAN = function() {
    return HOST + "/plan/add";
};

const EDIT_PLAN = function(planId) {
    return `${HOST}/plan/${planId}/edit`;
};

const AVAILABLE_SETTING = function() {
    return HOST + "/plan/availableSetting";
};

const DELETE_PLAN = function(planId) {
    return `${HOST}/plan/${planId}/remove`;
};

const TERMS_AND_SERVICES = function() {
    return HOST + "/termsAndServices";
};

const SAVE_PLAN_COURSES_LIST = function(planId) {
    return `${HOST}/plan/${planId}/save`;
};

const SEARCH = function() {
    return HOST + "/course/search";
};

const HEADER = function() {
    return { 'Content-Type': 'application/json' };
};

export default {
    LOGIN,
    REGISTER,
    LOGOUT,
    GET_PLANS,
    GET_COURSES_LIST,
    ADD_PLAN,
    EDIT_PLAN,
    AVAILABLE_SETTING,
    DELETE_PLAN,
    TERMS_AND_SERVICES,
    SAVE_PLAN_COURSES_LIST,
    SEARCH,
    HEADER
};